import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'iteration' })
export class IterationPipe implements PipeTransform {
  transform(value: number): any {
    return new Array(value).fill(1);
  }
}
